"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setIsMwReady = function (isReady) { return toolkit_1.createAction(constants_1.SET_IS_MW_READY)(isReady); };
exports.setMwCtxCount = function (count) { return toolkit_1.createAction(constants_1.SET_MW_CTX_COUNT)(count); };
exports.setScanDvbState = function (initState) {
    return toolkit_1.createAction(constants_1.SET_SCAN_DVB_STATE)(initState);
};
exports.setPlayerInstanceId = function (instanceId) {
    return toolkit_1.createAction(constants_1.SET_PLAYER_INSTANCE_ID)(instanceId);
};
exports.setIsPlayerSurfaceSet = function (isSet) {
    return toolkit_1.createAction(constants_1.SET_IS_PLAYER_SURFACE_SET)(isSet);
};
exports.setPlayerActionDone = function (isDone) {
    return toolkit_1.createAction(constants_1.SET_PLAYER_ACTION_DONE)(isDone);
};
exports.setMwEventSource = function (source) { return toolkit_1.createAction(constants_1.SET_MW_EVENT_SOURCE)(source); };
exports.setScanParams = function (params) {
    return toolkit_1.createAction(constants_1.SET_SCAN_PARAMS)(params);
};
exports.setIsCasHomeSet = function (initState) {
    return toolkit_1.createAction(constants_1.SET_IS_CAS_HOME_SET)(initState);
};
exports.setDvbSignalReservationId = function (reservationId) {
    return toolkit_1.createAction(constants_1.SET_DVB_RESERVATION_ID)(reservationId);
};
exports.setHasMail = function (hasMail) { return toolkit_1.createAction(constants_1.SET_HAS_MAIL)(hasMail); };
exports.setIsServiceStatusOpen = function (isStatusOpen) {
    return toolkit_1.createAction(constants_1.SET_IS_SERVICE_STATUS_OPEN)(isStatusOpen);
};
exports.setIsCasErrorModalDisplayed = function (isCasErrorModalDisplayed) {
    return toolkit_1.createAction(constants_1.SET_IS_CAS_MODAL_DISPLAYED)(isCasErrorModalDisplayed);
};
exports.setIsE016EntitlementError = function (isE016EntitlementError) {
    return toolkit_1.createAction(constants_1.SET_IS_E016_ENTITLEMENT_ERROR)(isE016EntitlementError);
};
exports.setQueryRecordingsState = function (recordingsState) {
    return toolkit_1.createAction(constants_1.SET_QUERY_RECORDINGS_STATE)(recordingsState);
};
exports.setIsDvbSignalOk = function (isOk) { return toolkit_1.createAction(constants_1.SET_IS_DVB_SIGAL_OK)(isOk); };
exports.setHasSatelliteConnection = function (hasConnection) {
    return toolkit_1.createAction(constants_1.SET_HAS_SATELLITE_CONNECTION)(hasConnection);
};
exports.setAutoLnbDetectionStatus = function (status) {
    return toolkit_1.createAction(constants_1.AUTO_LNB_DETECTION_STATUS)(status);
};
exports.setIsForceScan = function (status) { return toolkit_1.createAction(constants_1.SET_FORCE_SCAN)(status); };
//# sourceMappingURL=actions.js.map